import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);



export default class PacCronicos extends Component {

  state = {
    labels:[],
    values: [],
    loading: false
  }

  componentDidMount(){

    const { unidad_medica_user, periodo, backend } = this.props;

    fetch(`${backend}/pacientescronV2/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
          this.setState({
            labels: data.data.labels,
            values: data.data.values,
            loading:true
          });
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener la información de los pacientes crónicos.",
          });
          message.destroy()
      });

  }

  render(){

    const { labels, values, loading } = this.state;

    const options = {
      responsive: true,
      plugins:[ChartDataLabels],
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Edad de las mujeres embarazadas',
          font:{
            size:'28'
          }
        },
        datalabels:{
          color: '#ffffff',
          font: {
            weight: 'bold',
            size: '15'
          }
        }
      },
    };
    
    const data = {
      labels,
      // labels: ["9 a 17", "18 a 29", "30 a 40", "41 a 59"],
      datasets: [
        {
          // label: 'Dataset 1',
          // data: [8, 6,  1, 13, 30 ],
          data: values,
          backgroundColor: [
            'rgb(68, 115, 197, 1)',
            'rgb(197, 91, 15, 1)',
            'rgb(37, 175, 80, 1 )',
            'rgb(248, 192, 2, 1)',
            'rgb(109, 81, 140, 1)',
            'rgba(53, 179, 134, 1)',
            'rgba(248, 192, 2, 1)',
            'rgba(131, 150, 175, 1)',
            
            'rgba(255, 99, 132, 1)',
            'rgba(255, 159, 64, 1)',
            'rgba(255, 205, 86, 1)',
            'rgba(75, 192, 192, 1)',
            'rgba(54, 162, 235, 1)',
            'rgba(153, 102, 255, 1)',
            'rgba(201, 203, 207, 1)'
          ],
        }
      ],
    };

    return(
      loading?
      <Bar 
      width={600}
      height={150}
      options={options} 
      data={data} 
      />
      :<Spin size="small" />
    );
  }
}
